export const VARIATION = [
  'primary',
  'secondary',
  ''
]
